var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      attrs: { title: "Return to home screen!" },
      on: {
        click: function ($event) {
          return _vm.$emit("returnHome")
        },
      },
    },
    [
      _c("div", { staticClass: "home-button" }, [
        _c("div", { staticClass: "home-text" }, [_vm._v("HOME")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "center-icon" },
          [_c("fa", { attrs: { icon: ["fas", "home"], size: "1x" } })],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }